{
  "next": "次へ",
  "previous": "前へ"
}
